export default "__VITE_ASSET__p_NJd36jlm8nACpXawvJgw__"